export enum CoinType {
  ETHER = 60,
  TRON = 195,
}
